<template lang='pug'>
  //-
    @description 企业项目树单选弹框
    @author 李小龙
    @date 2018/6/11
  .project-select
    el-button(@click='openDialog')
      span {{curProjectName}}
      i.el-input__icon.el-icon-arrow-down
    el-dialog(:visible.sync='dialogShow' title='选择项目' width='800px')
      el-input(placeholder="输入关键字进行过滤" v-model="filterText")
      el-tree(@check='ok' :data='treeData' default-expand-all :filter-node-method="filterNode" node-key='nodeKey' ref='projectTree' show-checkbox)
        span.row(slot-scope='{node, data}')
          img(src='../assets/org.svg' v-if='data.nodeKey.startsWith("org")')
          img(src='../assets/project.svg' v-if='data.nodeKey.startsWith("project")')
          span {{data.label}}
      .btns(slot='footer')
        el-button(@click='selectAll') 选择全部
        el-button(type='danger' @click='selectNone') 取消选择
        el-button(type='primary' @click='dialogShow = false') 确定
</template>

<script>

export default {
  props: ['form'], //直接修改表单上的两个字段
  data() {
    return {
      allOrgIds: [],
      dialogShow: false,
      filterText: '',
      pidsToNames: {}, //项目id转名称映射
      oidsToNames: {}, //机构id转名称映射
      refreshInterval: null,
      treeData: [],
    }
  },
  watch: {
    filterText(val) {
      this.$refs.projectTree.filter(val)
    },
    dialogShow() {
      console.log("123="+this.dialogShow)
      if(!this.dialogShow) { //树的弹窗关闭时开始定时刷新树
        // this.refreshInterval = setInterval(this.refreshTree.bind(this), 30000) //每30秒刷新树
      } else {
        this.refreshTree();
        clearInterval(this.refreshInterval)
      }
    }
  },
  computed: {
    curProjectName() {
      if (this.form.orgIds == this.allOrgIds.join(',')) return '全部'
      var pString = this.form.projectIds&&this.form.projectIds.split(',').map(id => this.pidsToNames[id]).join(',')
      var oString = this.form.orgIds&&this.form.orgIds.split(',').map(id => this.oidsToNames[id]).join(',')
      var result
      if (pString == '' || oString == '') result = pString + oString
      else result = pString + ',' + oString
      return result||'请选择'
    }
  },
  mounted() {
    this.init()
    this.refreshInterval = setInterval(this.refreshTree.bind(this), 30000) //每30秒刷新树
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval)
  },
  methods: {
    filterNode(value, data) {
      return data.label.indexOf(value) !== -1
    },
    getTopCheckedNodes(nodeArr) {
      return nodeArr.reduce((total, current) => {
        if (current.checked) return total.concat([current])
        else return total.concat(this.getTopCheckedNodes(current.childNodes))
      }, [])
    },
    /** 初始化form、pidsToNames、allOrgIds、oidsToNames及treeData
     * 刷新时传入d代替sessionStorage.loginInfo，并且不重设值
    */
    init(d) {
      this.pidsToNames = {}
      this.oidsToNames = {}
      this.allOrgIds = []
      var loginInfo = d||JSON.parse(sessionStorage.loginInfo)
      var orgList = loginInfo.orgList
      if (orgList) { //运营账号
        var allPros = orgList.reduce((total, current) => {
          this.allOrgIds.push(current.value)
          this.$set(this.oidsToNames, current.value, current.desc)
          return current.orgProsList?total.concat(current.orgProsList):total
        }, [])
        var mostRecentPro = {dateTime: 0, value: ''}
        allPros.forEach(p => {
          if (p.dateTime > mostRecentPro.dateTime) mostRecentPro = p
          this.$set(this.pidsToNames, p.value, p.desc)
        })
        if (d==null) {
          this.$set(this.form, 'orgIds', '')
          this.$set(this.form, 'projectIds', String(mostRecentPro.value))
        }
        this.treeData = orgList.map(org => {
          return {
            label: org.desc,
            children: org.orgProsList.map(project => ({
              label: project.desc,
              nodeKey: 'project,'+project.value
            })),
            nodeKey: 'org,'+org.value,
          }
        })
      } else { //非监管账号
        if (d==null)
          this.$set(this.form, 'orgIds', '')
        this.allOrgIds.push(loginInfo.orgId)
        if (loginInfo.prosList==null) {
          if (d==null)
            this.$set(this.form, 'projectIds', '')
          return
        }
        if (d==null)
          this.$set(this.form, 'projectIds', String(loginInfo.prosList[0].value))
        loginInfo.prosList.forEach(p => {
          this.$set(this.pidsToNames, p.value, p.desc)
        })
        this.treeData = loginInfo.prosList.map(project => ({
          label: project.desc,
          nodeKey: 'project,'+project.value
        }))
      }
    },
    ok(data, checked) {
      var checkeds = this.getTopCheckedNodes(this.$refs.projectTree.root.childNodes).map(n => n.data.nodeKey)
      this.form.orgIds = checkeds.length==0?this.allOrgIds.join(','):checkeds.filter(c => c.startsWith('org,')).map(o => o.slice(4)).join(',')
      this.form.projectIds = checkeds.filter(c => c.startsWith('project,')).map(p => p.slice(8)).join(',')
    },
    openDialog() {
      this.dialogShow = true
      this.$nextTick(() => {
        if (this.form.orgIds == this.allOrgIds.join(','))
        // this.$refs.projectTree.setCheckedKeys([])
          this.checkedAll()
        else this.$refs.projectTree.setCheckedKeys(this.form.projectIds.split(',').map(p => 'project,'+p).concat(this.form.orgIds.split(',').map(o => 'org,'+o)))
      })
    },
    refreshTree() {
      var loginInfo = JSON.parse(sessionStorage.loginInfo)
      this.$app.get('刷新项目树', {platformId: loginInfo.platformId, userId: loginInfo.id}).then(d => {
        loginInfo.orgList = d.data.orgList
        loginInfo.prosList = d.data.prosList
        d.data.orgId = loginInfo.orgId
        sessionStorage.loginInfo = JSON.stringify(loginInfo)
        this.init(d.data)
      })
    },
    selectAll() {
      this.form.orgIds = this.allOrgIds.join(',')
      this.form.projectIds = ''
      this.checkedAll()
      // this.$refs.projectTree.setCheckedKeys([])
      this.dialogShow = false
    },
    checkedAll() {
      var checkedNodes=[]
      this.treeData.forEach(e => {
        checkedNodes.push(e.nodeKey)
        if (e.children&&e.children.length>0) {
          checkedNodes.concat(e.children.map(p=> p.nodeKey))
        }
      })
      this.$refs.projectTree.setCheckedKeys(checkedNodes)
    },
    selectNone() {
      this.$refs.projectTree.setCheckedKeys([])
      this.form.orgIds = ''
      this.form.projectIds = ''
    }
  }
}
</script>

<style lang='stylus' scoped>
.project-select
  >.el-button
    padding 0
    min-width 100px
    max-width 180px
    overflow hidden
    text-overflow ellipsis
    width auto
  .el-input
    margin-bottom 10px
  .row
    display flex
    align-items center
    img
      width 20px
      height 20px
      margin 0 5px
</style>
<style>
.project-select .el-dialog {
  max-height: 600px!important;
}
.project-select .btns .el-button {
  margin: 0px 10px!important;
}
</style>




// WEBPACK FOOTER //
// src/components/project-select.vue